// extracted by mini-css-extract-plugin
export default {"buyersChoice":"HomePage_buyersChoice__kK-tK"};